module.exports = __webpack_public_path__ + "static/media/cart.8bf1af37.svg";